<h2 mat-dialog-title> {{ data.title }}</h2>
<mat-dialog-content class="mat-typography" >
  <div *ngIf="!data.component" [innerHTML]="data.content"></div>
  <ng-template formHost></ng-template>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button  color="warn" [mat-dialog-close]="false" *ngIf="data.showButtonCancel">Cancelar</button>
  <button mat-flat-button  color="primary" [mat-dialog-close]="true" cdkFocusInitial>{{ data.buttonText }}</button> 
</mat-dialog-actions>